import {
  CompanyStructurePlanningGroup, CompanyStructureForPlanningResponse
} from "@/types/service-response";

export class PlanningGroup {
  public label: string

  public constructor(
    readonly id: number, // ID
    readonly planningGroup: number, // Planungsgruppe
    readonly planningGroupName: string, // PlanungsgruppeName
    readonly department: number, // Abteilung
    readonly departmentName: string, // AbteilungenName
    readonly language: number, // sprache
    readonly color: string, // Farbe
  ) {
    this.label = planningGroupName
  }

  static createFromResponse(responseData: CompanyStructureForPlanningResponse): Array<PlanningGroup> {
    let result: Array<PlanningGroup> = []
    if (responseData.mitarbeiters) {
      result = responseData.planninggroups.map((planningGroup: CompanyStructurePlanningGroup) => {
        return new PlanningGroup(
          planningGroup.ID,
          planningGroup.Planungsgruppe,
          planningGroup.PlanungsgruppeName,
          planningGroup.Abteilung,
          planningGroup.AbteilungenName,
          planningGroup.sprache,
          planningGroup.Farbe
        )
      })
    }
    return result
  }
}
